import React from 'react';
import { Link } from 'react-router-dom';
import config from 'config';
const SubNavigation = () => {
  const gatewayUrl = config.QRS.GatewayNavURL;
  const powerBIReportsUrl = config.QRS.PowerBIReportsUrl;
  const uwTemplatesUrl = config.LOCATION.uwTemplatesUrl;
  const auTemplatesUrl = config.LOCATION.auTemplatesUrl;

  return (
    <div>
      <>
        <p className="text-neutral-grey">
          <u>DOCUMENTS</u>
        </p>

        <p>
          <Link target="_blank" to={uwTemplatesUrl}>
            {' '}
            UW Templates{' '}
          </Link>
        </p>
        <p>
          <Link target="_blank" to={auTemplatesUrl}>
            {' '}
            AU Templates{' '}
          </Link>
        </p>
      </>
      <p className="text-neutral-grey">
        <u>SYSTEM SOURCE</u>
      </p>
      <p>
        <Link target="_blank" to={gatewayUrl}>
          Gateway{' '}
        </Link>
      </p>
      <p>
        <Link target="_blank" to={powerBIReportsUrl}>
          PowerBI Reports{' '}
        </Link>
      </p>
    </div>
  );
};

export default SubNavigation;
